import React , {memo} from 'react'
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Formatprice from '../Helper/Formatprice';
import { BASE_URL } from '../../Config/Config';
import { UseGlobelcourse } from '../allcoursecontaxt/ALLCoursecontaxt';
import { UseGlobellogin } from '../Logincontaxt.jsx/Logincontex';
import { Usecartcontaxt } from '../cartcontaxt/cart_contaxt';

function Course_Card({ curdata }) {
       const{isLoggedIn} = UseGlobellogin();    
       const {AddTocart} = Usecartcontaxt();
       const navigate = useNavigate();
       const location = useLocation();
  
const handleAddToCartClick = (courseid) => {
      if (!courseid) return;

  if (isLoggedIn) {
    AddTocart(courseid); // assuming this is async (optional: handle success/failure)
    navigate('/cartpage'); 
  } else {
    // Redirect to login and preserve location
    navigate('/login', { state: { from: location } });
  }
};

const count = 1;

console.log("render 1" , count + 1);

  return (
    <>
    
      <div className="course-box" >
        <div className="course-img">
          <img src={ curdata.CourseMaster_tumbimage ? `${BASE_URL}${curdata.CourseMaster_tumbimage}`:'/assets/img/AA_LOgo_Black.png'} alt="Auratech Course Image" />

          <span className="tag">
            <i className="fas fa-clock" />{curdata.CourseMaster_duration}&nbsp;{curdata.CourseMaster_duration_unit}
          </span>
        </div>
        <div className="course-content">
          {/* <div className="course-rating">

                      <div
                        className="star-rating"
                        role="img"
                        aria-label={`Rated ${curdata?.CourseMaster_rating} out of 5`}
                      >
                        <span style={{ width: `${(curdata?.CourseMaster_rating / 5) * 100}%`, }}>
                          Rated <strong className="rating">{curdata?.CourseMaster_rating}</strong> out of 5
                        </span>
                      </div>
                           ({curdata.CourseMaster_rating})
                    </div> */}
<div className="d-flex justify-content-between align-items-center">
  <div className="offer-tag">
    {curdata.CourseMaster_fee > 0 ? (<Formatprice price={curdata.CourseMaster_fee} />) : "Free"}
  </div>

  <span className="tag">
    <i className="fas fa-clock me-2"  />
    {curdata.CourseMaster_duration}&nbsp;{curdata.CourseMaster_duration_unit}
  </span>
</div>


          <hr className="mute" style={{ margin: 6, padding: 0 }} />
          <h3 className="course-title text-primary">

          <h3
  className="course-title text-primary"
  style={{
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    lineHeight: '1.3em',
    maxHeight: '2.6em',
    minHeight: '2.6em', 

  }}
>
  <NavLink to={`/course-detail/${curdata.slug}`} onClick={() => window.scrollTo(0, 0)}>
    {curdata.CourseMaster_title}
  </NavLink>
</h3>


          </h3>
          <div className="description-box">
            <p>
              {curdata.Description?.replace(/<[^>]+>/g, '').slice(0, 40)}...
              <span className="text-primary fw-bold">
                <NavLink to={`/course-detail/${curdata.slug}`} className="th-bt link-btn">
                  Know More <i className="fa-solid fa-arrow-right ms-2 " />
                </NavLink>
              </span>
            </p>
            
             <button className="th-btn style4" onClick={() => handleAddToCartClick(curdata.id)}>
                { isLoggedIn ?"Add To Cart": "Enroll Now" }<i className="fas fa-arrow-right ms-2" />
                  </button> 
          </div>


          {/* <div className="course-meta">
                      <span>
                        <i className="fal fa-file" />
                        Lesson {curdata.course_level}
                      </span>
                      <span>
                        <i className="fal fa-user" />
                        Students {curdata.Number_of_students}
                      </span>
                      <span>
                        <i className="fal fa-chart-simple" />
                        {curdata.course_level}
                      </span>
                    </div> */}
          <div className="course-author">
            <div className="author-info">
              {/* <img src="/assets/img/course/author.png" alt="author" /> */}
              {/* <NavLink to="/team-detail" className="author-name">{curdata?.CourseMaster_Courseinstructor?.CourseInstructor_name}</NavLink> */}
            </div>



          </div>
        </div>
     
      </div>


    </>
  )
}

export default Course_Card